export default __webpack_public_path__ + "static/offroad-a55cc9506396d6e36a1d43deea6c86b1.png";